// extracted by mini-css-extract-plugin
export var animationContainer = "_gk-0";
export var asteriskIcon = "_gk-8";
export var conversationLeftSection = "_gk-4";
export var conversationListItem = "_gk-3";
export var conversationMiddleSection = "_gk-5";
export var conversationRightSection = "_gk-6";
export var detailsContent = "_gk-1";
export var listContainer = "_gk-7";
export var modalContent = "_gk-2";